import React, { useEffect, useState } from 'react';
import ResultCard from '../cards/ResultCard';
import '../../styles/RealResults.css';
import { getFeedbacks } from '../../api/contentApi';
import ApiContentState from '../common/ApiContentState';

export default function RealResults({
  title = "Our Students",
  highlight = "Feedback.",
  viewAllLink = "#stories",
  showViewAll = true,
  items = [],
  useApi = true,
  className = ""
}) {
  const [activePlayingId, setActivePlayingId] = useState(null);
  const [apiItems, setApiItems] = useState([]);
  const [isLoading, setIsLoading] = useState(useApi);
  const [loadError, setLoadError] = useState("");

  useEffect(() => {
    if (!useApi) {
      setIsLoading(false);
      return;
    }
    getFeedbacks()
      .then((items) => setApiItems(Array.isArray(items) ? items.map((item) => ({
        id: item.id,
        name: item.name,
        niche: item.courseTitle || 'Creator learner',
        rating: item.rating,
        feedbackText: item.feedback,
        videoThumbnail: item.imageUrl,
        avatarUrl: item.imageUrl,
      })) : []))
      .catch((error) => {
        console.error('Unable to load feedbacks:', error);
        setLoadError("Unable to load student feedback.");
      })
      .finally(() => setIsLoading(false));
  }, [useApi]);

  const results = useApi ? apiItems : items;
  const visibleResults = (results || []).slice(0, 3);

  return (
    <section className={`homepage-section cd-reusable-results-section ${className}`}>
      <div className="section-flex-header">
        <h2>
          {title} <span>{highlight}</span>
        </h2>
        {showViewAll && (
          <a href={viewAllLink} className="global-redirect-link results-all-desktop">
            View All Stories ➔
          </a>
        )}
      </div>

      <div className="horizontal-carousel-viewport">
        {isLoading || loadError || visibleResults.length === 0 ? (
          <ApiContentState
            loading={isLoading}
            error={loadError}
            emptyMessage="No student feedback is available right now."
          />
        ) : visibleResults.map((data) => (
          <ResultCard
            key={data.id}
            resultData={data}
            isPlaying={activePlayingId === data.id}
            onPlay={() => setActivePlayingId(data.id)}
            onPause={() => setActivePlayingId(null)}
          />
        ))}
      </div>

      {showViewAll && (
        <div className="results-all-mobile-wrapper">
          <a href={viewAllLink} className="global-redirect-link results-all-mobile">
            View All Stories ➔
          </a>
        </div>
      )}
    </section>
  );
}